import React from 'react';
const ConfirmedModal = ({gameData, setGameData, closeGame,  heading, description = ''}) => {
    const isCloseConfirmPopup = gameData?.isClosedConfirmPopup;
    if (!isCloseConfirmPopup) {
        return;
    }
    const handleSetModal = (e) => {
        e.preventDefault();
        setGameData({});
    }
    const handleCloseGame = () => {
        closeGame();
    }
    return (isCloseConfirmPopup &&
        <section className={`modal alert z-[99]`}>
            <div className="overlay">
                <span className="loading-decor-l" />
                <span className="loading-decor-r" />
            </div>
            <div className="content relative">
                <div className="container md:!px-4 !px-8">
                    <div className={'alert-modal flex-col relative'}>
                        <div className={'alert-content'}>
                            <h3 className={'my-4'}>{heading}</h3>
                            <p className={'text-xs'}>{description}</p>
                            <div className={'actions mt-6 flex md:flex-row flex-col justify-center items-center gap-4'}>
                                <span className={'play-button md:w-auto w-full'}>
                                    <button className={'btn btn-header w-full'} onClick={handleCloseGame} type="button">
                                        <span className={`md:min-w-[160px] !bg-cover !px-[14px] !pb-[13px] 
                                        !pt-[11px] md:before:mr-[6px] min-w-[48px] min-h-[48px] md:min-w-auto  md:min-h-auto`}>
                                            <span className='!p-0 !bg-none'>Yes</span>
                                        </span>
                                    </button>
                                </span>
                                <button type="button"
                                      className="btn btn-header md:w-auto w-full"
                                      onClick={handleSetModal}>
                                    <span className={`${!isCloseConfirmPopup ?? 'before:bg-lideboard-icon before:bg-cover before:bg-no-repeat before:w-[20px] before:h-[18px]'}
                                    md:min-w-[160px] !bg-cover !px-[14px] py-[21px] pt-[12px] md:before:mr-[6px] min-w-[52px] min-h-[48px] md:min-w-auto  md:min-h-auto`}>
                                        <span className='!p-0 !bg-none'> No </span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ConfirmedModal;
